import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as tpaDailyReportAction from "../../../store/tpadaily-report/action";

import {
    Col,
    Container,
    Input,
    InputGroup,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    DELETE_SHRINKAGE_RP_TPA_DAILY_REPORT,
    GET_SHRINKAGE_RP_TPA_DAILY_REPORT,
    SAVE_LIST_SHRINKAGE_RP_TPA_DAILY_REPORT,
    SAVE_SHRINKAGE_RP_TPA_DAILY_REPORT
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";

import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import debounce from "lodash.debounce";
import moment from "moment";
import { useDispatch } from "react-redux";

function TableThree(props) {

    let history = useHistory();
    let { pid } = useParams();

    const dispatch = useDispatch();
    const permission = getPermission();
    const searchObj = { TPADAILY_PID: pid, };
    const [tableThreeModelList, setTableThreeModelList] = useState([]);

    //render Index//
    const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
    //render Index//

    const rowStyleFontWhite = (row, rowIndex) => {
        const style = {};
        // style.fontWeight = 'bold';
        style.color = 'white';

        return style;
    };

    //onInit//
    useEffect(function () {
        fetchData();
        // resetSearch();
        // resetModel();
        // setModelDeviceList(listData);
    }, [props.tpaDailyReportPid]);
    //onInit//

    const compare = (a, b) => {
        // console.log(a, b);
        if (a.SHRINKAGECOLUMN_ORDER < b.SHRINKAGECOLUMN_ORDER) {
            return -1;
        }
        if (a.SHRINKAGECOLUMN_ORDER > b.SHRINKAGECOLUMN_ORDER) {
            return 1;
        }
        return 0;
    }

    const setDispatchAction = useMemo(
        () =>
            debounce((value) => {
                // console.log(value);
                dispatch(
                    tpaDailyReportAction.setTableThreeShrinkageTPAToState(value)
                );
            }, 300),
        []
    );

    useEffect(() => {
        setDispatchAction(tableThreeModelList);
    }, [tableThreeModelList]);

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_SHRINKAGE_RP_TPA_DAILY_REPORT, { TPADAILY_PID: props.tpaDailyReportPid });
            // console.log(res);
            setTableThreeModelList(res.data.rpTPAShrinkageList.sort(compare).map((obj) => ({
                ...obj, GAS_DATA: obj.GAS_DATA.toFixed(4),
            }))
            );
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };

    function RenderList(prop) {
        // console.log(prop);
        return (
            <tr>
                {/* <td className="text-center">{prop.indexlist}</td> */}
                <td className="text-center" style={{ fontSize: "14px" }}>{prop.data.SHRINKAGECOLUMN_NAME}</td>
                <td>
                    <div className="d-sm-flex align-items-center justify-content-center">
                        <Col sm="4">
                            <Input
                                style={{
                                    // direction: "rtl",
                                    textAlign: "right",
                                }}
                                readOnly={props.readOnly}
                                type="number"
                                className="form-control basicborder"
                                onChange={e =>
                                    setTableThreeModelList(prevData => {
                                        return prevData.map(item => {
                                            if (item.PID === prop.data.PID) {
                                                return { ...item, GAS_DATA: e.target.value };
                                            }
                                            return { ...item };
                                        });
                                    })
                                }
                                value={prop.data.GAS_DATA}
                            />
                        </Col>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        // <div>
        <Row>
            <Col sm="1"></Col>
            <Col sm="10">
                <div className="table-responsive">
                    {/* hover-table-highlight */}

                    <Table className="table table-bordered mb-0">
                        <thead>
                            <tr>
                                <th colSpan={2} style={{ backgroundColor: "#556ee64a", color: "#FFFFFF", textAlign: "center", width: "100%" }}>ข้อมูลปริมาณ Shrinkage Gas และตัวแปรอื่น ๆ(หน่วย : MMBTU)</th>
                            </tr>
                            <tr>
                                <th style={{ backgroundColor: "#556ee678", color: "#FFFFFF", textAlign: "center", width: "25%" }}>รายการ</th>
                                <th style={{ backgroundColor: "#667eef85", color: "#FFFFFF", textAlign: "center", width: "25%" }}>Total Onshore</th>
                            </tr>
                        </thead>
                        <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                            {tableThreeModelList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
                            {/* <tr >
                                <td><label style={{ fontSize: "14px" }}>ปริมาณ Shrinkage Gas</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center">
                                        <Col sm="4">
                                            <Input
                                                type="number"
                                                className="form-control basicborder"
                                            // onChange={(e) => setCreateModel(
                                            //     {
                                            //         ...createModel,
                                            //         ALIAS_NAME: e.target.value
                                            //     })
                                            // }
                                            // value={createModel.ALIAS_NAME}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซเชื้อเพลิง</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                type="number"
                                                className="form-control basicborder"
                                            // onChange={(e) => setCreateModel(
                                            //     {
                                            //         ...createModel,
                                            //         ALIAS_NAME: e.target.value
                                            //     })
                                            // }
                                            // value={createModel.ALIAS_NAME}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณ Gas In และ Commissioning</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                type="number"
                                                className="form-control basicborder"
                                            // onChange={(e) => setCreateModel(
                                            //     {
                                            //         ...createModel,
                                            //         ALIAS_NAME: e.target.value
                                            //     })
                                            // }
                                            // value={createModel.ALIAS_NAME}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณก๊าซที่ระบายออกนอกระบบส่งก๊าซ</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                type="number"
                                                className="form-control basicborder"
                                            // onChange={(e) => setCreateModel(
                                            //     {
                                            //         ...createModel,
                                            //         ALIAS_NAME: e.target.value
                                            //     })
                                            // }
                                            // value={createModel.ALIAS_NAME}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr> */}
                            {/* <tr>
                                <td><label style={{ fontSize: "14px" }}>ปริมาณ Gas In และ Commissioning</label></td>
                                <td>
                                    <div className="d-sm-flex align-items-center justify-content-center" >
                                        <Col sm="4">
                                            <Input
                                                type="number"
                                                className="form-control basicborder"
                                            // onChange={(e) => setCreateModel(
                                            //     {
                                            //         ...createModel,
                                            //         ALIAS_NAME: e.target.value
                                            //     })
                                            // }
                                            // value={createModel.ALIAS_NAME}
                                            />
                                        </Col>
                                    </div>
                                </td>
                            </tr> */}
                        </tbody>
                    </Table>
                </div>
            </Col>
            <Col sm="1"></Col>
        </Row>

        // </div>
    );
}

TableThree.propTypes = {
    t: PropTypes.any,
    tpaDailyReportPid: PropTypes.any,
    readOnly : PropTypes.any,
};

export default TableThree;

